/**
* @prop --uic-header-menu-indicator-color: color of the indicator
* @prop --uic-header-menu-indicator-transition: duration and speed of the transition
*/
uic-header-menu-indicator {
    display: block;
    position: absolute;
    background-color: var(--uic-header-menu-indicator-color);
    transition: transform var(--uic-header-menu-indicator-transition),
        width var(--uic-header-menu-indicator-transition);
}

.uic-header-menu-indicator--horizontal {
    top: auto;
    bottom: 0;
    left: 0;
    width: 0;
    height: 4px;
}

.uic-header-menu-indicator--vertical {
    top: 0;
    bottom: auto;
    left: 0;
    width: 4px;
    height: 0;
}
